import { Platform, useWindowDimensions } from 'react-native';
export default function useMedia() {
  let maxBreakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 752;
  let minBreakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 576;
  const {
    width
  } = useWindowDimensions();

  if (Platform.OS === 'web') {
    return width >= minBreakpoint && width <= maxBreakpoint;
  }

  return false;
}
//# sourceMappingURL=use-media.js.map